export const porcentageProgress = (currentStep: number, fields: string[])  => {
    const progress = Math.round((currentStep / (fields.length - 1)) * 100);
    return progress;
}

 